import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, isRef as _isRef, vModelText as _vModelText, mergeProps as _mergeProps, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, Transition as _Transition, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-8 flex justify-center items-center"
}
const _hoisted_2 = {
  key: 1,
  class: "p-6"
}
const _hoisted_3 = {
  key: 2,
  class: "p-6 space-y-5"
}
const _hoisted_4 = {
  key: 0,
  class: "mt-2 text-sm text-red-600"
}
const _hoisted_5 = { class: "mt-2 text-xs text-slate-500 text-right" }
const _hoisted_6 = {
  key: 0,
  class: "mt-2 text-sm text-red-600"
}
const _hoisted_7 = { class: "mt-2 text-xs text-slate-500 text-right" }
const _hoisted_8 = { class: "block text-sm font-semibold text-slate-700 mb-2" }
const _hoisted_9 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_10 = {
  key: 1,
  class: "text-slate-500 text-xs"
}
const _hoisted_11 = { class: "space-y-3" }
const _hoisted_12 = {
  key: 0,
  class: "text-sm text-red-600"
}
const _hoisted_13 = {
  key: 1,
  class: "relative w-full h-48 bg-slate-100 rounded-xl overflow-hidden border-2 border-slate-200"
}
const _hoisted_14 = ["src"]

import { ref, watch, computed } from "vue";
import { useForm } from "vee-validate";
import { toTypedSchema } from "@vee-validate/yup";
import * as yup from "yup";
import AdminModalShell from "@/share/components/admin/AdminModalShell.vue";
import AdminModalHeader from "@/share/components/admin/AdminModalHeader.vue";
import AdminModalFooter from "@/share/components/admin/AdminModalFooter.vue";
import AdminButton from "@/share/components/admin/AdminButton.vue";
import { useMarcaVehiculoFindOne } from "../../composables/marcaVehiculosComposables";

interface Props {
  isOpen: boolean;
  marcaId?: string;
  isSaving?: boolean;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'FormularioMarcaVehiculo',
  props: {
    isOpen: { type: Boolean },
    marcaId: {},
    isSaving: { type: Boolean, default: false }
  },
  emits: ["close", "save", "update"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const schema = toTypedSchema(
  yup.object({
    nombreMarca: yup
      .string()
      .required("El nombre es obligatorio")
      .trim()
      .min(3, "El nombre debe tener al menos 3 caracteres")
      .max(50, "El nombre no puede exceder 50 caracteres")
      .matches(
        /^[a-zA-ZáéíóúÁÉÍÓÚñÑ0-9\s]+$/,
        "El nombre solo puede contener letras, números y espacios"
      ),
    descripcionMarca: yup
      .string()
      .optional()
      .default("")
      .max(200, "La descripción no puede exceder 200 caracteres"),
  })
);

const { defineField, errors, handleSubmit, meta, resetForm, setValues } =
  useForm({
    validationSchema: schema,
    initialValues: {
      nombreMarca: "",
      descripcionMarca: "",
    },
  });

const [nombreMarca, nombreMarcaAttrs] = defineField("nombreMarca");
const [descripcionMarca, descripcionMarcaAttrs] =
  defineField("descripcionMarca");

const imagen = ref<File | null>(null);
const imagenPreview = ref<string | null>(null);
const errorImagen = ref("");

const marcaIdRef = computed(() => props.marcaId || "");
const {
  data: marcaData,
  isPending,
  isError,
} = useMarcaVehiculoFindOne(marcaIdRef);
const isEditMode = computed(() => !!props.marcaId);

const imagenRequeridaOk = computed(
  () => isEditMode.value || imagen.value !== null
);

watch(
  marcaData,
  (newData) => {
    const marca = newData?.data?.data;
    if (marca && typeof marca === "object" && marca.nombreMarca) {
      setValues({
        nombreMarca: marca.nombreMarca || "",
        descripcionMarca: marca.descripcionMarca || "",
      });
      if (marca.archivo?.url) imagenPreview.value = marca.archivo.url;
    }
  },
  { immediate: true, deep: true }
);

watch(
  () => props.isOpen,
  (isOpen) => {
    if (!isOpen && !isEditMode.value) limpiarCampos();
  }
);

function limpiarCampos() {
  resetForm({
    values: { nombreMarca: "", descripcionMarca: "" },
  });
  imagen.value = null;
  imagenPreview.value = null;
  errorImagen.value = "";
  const fileInput = document.querySelector(
    'input[type="file"]'
  ) as HTMLInputElement;
  if (fileInput) fileInput.value = "";
}

const handleImageChange = (e: Event) => {
  const target = e.target as HTMLInputElement;
  if (target.files && target.files[0]) {
    const file = target.files[0];
    if (file.size > 5 * 1024 * 1024) {
      alert("La imagen no puede superar los 5MB");
      return;
    }
    const allowedTypes = [
      "image/jpeg",
      "image/jpg",
      "image/png",
      "image/gif",
      "image/webp",
    ];
    if (!allowedTypes.includes(file.type)) {
      alert("Formato no válido. Usa: JPEG, PNG, GIF o WEBP");
      return;
    }
    imagen.value = file;
    errorImagen.value = "";
    const reader = new FileReader();
    reader.onload = (event) => {
      if (event.target?.result)
        imagenPreview.value = event.target.result as string;
    };
    reader.readAsDataURL(file);
  }
};

const removeImage = () => {
  imagen.value = null;
  imagenPreview.value = null;
  const fileInput = document.querySelector(
    'input[type="file"]'
  ) as HTMLInputElement;
  if (fileInput) fileInput.value = "";
};

const handleSave = handleSubmit((vals) => {
  if (!isEditMode.value && !imagen.value) {
    errorImagen.value = "La imagen es obligatoria";
    return;
  }
  errorImagen.value = "";

  const formData = new FormData();
  formData.append("nombreMarca", vals.nombreMarca.trim());
  if (vals.descripcionMarca.trim())
    formData.append("descripcionMarca", vals.descripcionMarca.trim());
  if (imagen.value) formData.append("imagen", imagen.value);

  if (isEditMode.value && props.marcaId)
    emit("update", props.marcaId, formData);
  else emit("save", formData);
});

const handleClose = () => {
  limpiarCampos();
  emit("close");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      (__props.isOpen)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm z-40 flex items-center justify-center p-4",
            onClick: _withModifiers(handleClose, ["self"])
          }, [
            _createVNode(_Transition, { name: "scale" }, {
              default: _withCtx(() => [
                (__props.isOpen)
                  ? (_openBlock(), _createBlock(AdminModalShell, { key: 0 }, {
                      header: _withCtx(() => [
                        _createVNode(AdminModalHeader, {
                          variant: "dark",
                          title: 
                isEditMode.value ? 'Editar Marca Vehiculo' : 'Nueva Marca Vehiculo'
              ,
                          onClose: handleClose
                        }, {
                          icon: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                            _createElementVNode("svg", {
                              class: "w-7 h-7",
                              fill: "none",
                              stroke: "currentColor",
                              viewBox: "0 0 24 24"
                            }, [
                              _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "2",
                                d: "M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"
                              })
                            ], -1)
                          ]))]),
                          _: 1
                        }, 8, ["title"])
                      ]),
                      footer: _withCtx(() => [
                        _createVNode(AdminModalFooter, { "rounded-bottom": "" }, {
                          default: _withCtx(() => [
                            _createVNode(AdminButton, {
                              variant: "secondary",
                              onClick: handleClose
                            }, {
                              default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                                _createTextVNode(" Cancelar ", -1)
                              ]))]),
                              _: 1
                            }),
                            _createVNode(AdminButton, {
                              variant: "info",
                              disabled: 
                  !_unref(meta).valid ||
                  !imagenRequeridaOk.value ||
                  (_unref(isPending) && isEditMode.value) ||
                  props.isSaving
                ,
                              loading: props.isSaving,
                              onClick: _unref(handleSave)
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(props.isSaving
                    ? "Guardando…"
                    : isEditMode.value
                      ? "Actualizar"
                      : "Guardar"), 1)
                              ]),
                              _: 1
                            }, 8, ["disabled", "loading", "onClick"])
                          ]),
                          _: 1
                        })
                      ]),
                      default: _withCtx(() => [
                        (_unref(isPending) && isEditMode.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[3] || (_cache[3] = [
                              _createElementVNode("div", { class: "animate-spin rounded-full h-12 w-12 border-b-2 border-red-600" }, null, -1)
                            ]))]))
                          : (_unref(isError) && isEditMode.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[4] || (_cache[4] = [
                                _createElementVNode("div", { class: "bg-red-50 border-2 border-red-200 rounded-xl p-4 text-center" }, [
                                  _createElementVNode("p", { class: "text-red-600 font-semibold" }, " Error al cargar la Marca Vehiculo ")
                                ], -1)
                              ]))]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                _createElementVNode("div", null, [
                                  _cache[5] || (_cache[5] = _createElementVNode("label", { class: "block text-sm font-semibold text-slate-700 mb-2" }, [
                                    _createTextVNode(" Nombre de Marca Vehiculo "),
                                    _createElementVNode("span", { class: "text-red-500" }, "*")
                                  ], -1)),
                                  _withDirectives(_createElementVNode("input", _mergeProps({
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(nombreMarca) ? (nombreMarca).value = $event : null))
                                  }, _unref(nombreMarcaAttrs), {
                                    type: "text",
                                    placeholder: "Ej: Toyota, Honda, Ford...",
                                    maxlength: "50",
                                    class: [
                  'w-full px-4 py-3 border-2 rounded-xl transition-all outline-none',
                  _unref(errors).nombreMarca
                    ? 'border-red-300 focus:border-red-500 focus:ring-2 focus:ring-red-200'
                    : 'border-slate-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-200',
                ]
                                  }), null, 16), [
                                    [_vModelText, _unref(nombreMarca)]
                                  ]),
                                  (_unref(errors).nombreMarca)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_unref(errors).nombreMarca), 1))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(nombreMarca).length) + "/50 caracteres ", 1)
                                ]),
                                _createElementVNode("div", null, [
                                  _cache[6] || (_cache[6] = _createElementVNode("label", { class: "block text-sm font-semibold text-slate-700 mb-2" }, " Descripción ", -1)),
                                  _withDirectives(_createElementVNode("textarea", _mergeProps({
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(descripcionMarca) ? (descripcionMarca).value = $event : null))
                                  }, _unref(descripcionMarcaAttrs), {
                                    placeholder: "Describe la Marca Vehiculo...",
                                    rows: "5",
                                    maxlength: "200",
                                    class: [
                  'w-full px-4 py-3 border-2 rounded-xl transition-all outline-none resize-none',
                  _unref(errors).descripcionMarca
                    ? 'border-red-300 focus:border-red-500 focus:ring-2 focus:ring-red-200'
                    : 'border-slate-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-200',
                ]
                                  }), null, 16), [
                                    [_vModelText, _unref(descripcionMarca)]
                                  ]),
                                  (_unref(errors).descripcionMarca)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_unref(errors).descripcionMarca), 1))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(descripcionMarca).length) + "/200 caracteres ", 1)
                                ]),
                                _createElementVNode("div", null, [
                                  _createElementVNode("label", _hoisted_8, [
                                    _cache[7] || (_cache[7] = _createTextVNode(" Imagen de la Marca ", -1)),
                                    (!isEditMode.value)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_9, "*"))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_10, "(opcional)"))
                                  ]),
                                  _createElementVNode("div", _hoisted_11, [
                                    _createElementVNode("input", {
                                      type: "file",
                                      accept: "image/jpeg,image/jpg,image/png,image/gif,image/webp",
                                      onChange: handleImageChange,
                                      class: _normalizeClass([
                    'w-full px-4 py-3 border-2 rounded-xl transition-all outline-none file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100 focus:ring-2',
                    errorImagen.value
                      ? 'border-red-300 focus:border-red-500 focus:ring-red-200'
                      : 'border-slate-200 focus:border-blue-500 focus:ring-blue-200',
                  ])
                                    }, null, 34),
                                    (errorImagen.value)
                                      ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(errorImagen.value), 1))
                                      : _createCommentVNode("", true),
                                    (imagenPreview.value)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                          _createElementVNode("img", {
                                            src: imagenPreview.value,
                                            alt: "Vista previa de la imagen",
                                            class: "w-full h-full object-contain"
                                          }, null, 8, _hoisted_14),
                                          _createElementVNode("button", {
                                            onClick: removeImage,
                                            type: "button",
                                            class: "absolute top-2 right-2 bg-red-500 text-white rounded-full p-2 hover:bg-red-600 transition-colors shadow-lg"
                                          }, [...(_cache[8] || (_cache[8] = [
                                            _createElementVNode("svg", {
                                              class: "w-4 h-4",
                                              fill: "none",
                                              stroke: "currentColor",
                                              viewBox: "0 0 24 24"
                                            }, [
                                              _createElementVNode("path", {
                                                "stroke-linecap": "round",
                                                "stroke-linejoin": "round",
                                                "stroke-width": "2",
                                                d: "M6 18L18 6M6 6l12 12"
                                              })
                                            ], -1)
                                          ]))])
                                        ]))
                                      : _createCommentVNode("", true),
                                    _cache[9] || (_cache[9] = _createElementVNode("p", { class: "text-xs text-slate-500" }, " Formatos permitidos: JPEG, PNG, GIF, WEBP. Tamaño máximo: 5MB ", -1))
                                  ])
                                ])
                              ]))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})